import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  useEffect(() => {
    const hamburger = document.querySelector('.hamburger');
    const sidebar = document.getElementById('sidebar');
    const closeSidebar = document.querySelector('.close-sidebar');
    if (hamburger && sidebar && closeSidebar) {
      hamburger.onclick = () => sidebar.classList.add('active');
      closeSidebar.onclick = () => sidebar.classList.remove('active');
    }
    return () => {
      if (hamburger) hamburger.onclick = null;
      if (closeSidebar) closeSidebar.onclick = null;
    };
  }, []);

  return (
    <main className="about-us-page">
      <nav className="regular-navbar">
        <Link className="logo" to="/">
          <img src="/logo.jpg" alt="company logo" />
        </Link>
        <div className="hamburger">
          <img src="/static/media/hamburger-black.c116047ebd06e70caac47be95fd90698.svg" alt="menu" />
        </div>
        <div className="links">
          <div className="void"></div>
          <div className="cont">
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About us</Link></li>
              <li><Link to="/loans">Loans</Link></li>
              <li><Link to="/savings-investments">Savings & Investment</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
            <div className="btns"><button className="transparent"><Link to="/register">Register</Link></button><button className="blue"><Link to="/login">Sign In</Link></button></div>
          </div>
        </div>
      </nav>
      {/* Sidebar for mobile only, not for desktop */}
      <div id="sidebar">
        <ul>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div></div>
            <div className="close-sidebar">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
            </div>
          </div>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About us</Link></li>
          <li><Link to="/loans">Loans</Link></li>
          <li><Link to="/savings-investments">Savings & Investment</Link></li>
          <li><Link to="/contact">Contact Us</Link></li>
          <div className="btnss" style={{ marginTop: 14 }}>
            <button className="transparent" style={{ marginRight: 5 }}><Link to="/register">Register</Link></button>
            <button className="blue"><Link to="/login">Sign In</Link></button>
          </div>
        </ul>
      </div>
      <header className="page-header">
        <div className="text-info">
          <h1>About Us</h1>
          <p>We're committed to providing our customers with the best possible banking experience. From our wide range of banking products and services to our commitment to safety and security, we're here to help you achieve your financial goals and build a better financial future.</p>
        </div>
        <div className="img"><img src="/static/media/about-us-page-header.067bbcc10a8c77548718.webp" alt="About Us" /></div>
      </header>
      <section className="our-values">
        <h2 className="title">Our Values</h2>
        <p className="sub-title">Our values are the foundation of everything we do .We believe in putting our customers first. That's why we're committed to providing the highest level of service and support, whether you're opening a new account or applying for a loan. We're also committed to safety and security, and we use advanced technology and security measures to protect your information and prevent fraud.</p>
        <div className="values">
          <div className="info">
            <h3>Integrity</h3>
            <p>We believe in doing what's right, even when it's not easy. We hold ourselves to the highest ethical standards, and we are committed to transparency, honesty, and fairness in all our dealings.</p>
            <div className="btns">
              <img src="/static/media/prev-arrow-grey.7da7bf70be64f971bfaf2d26fb6354da.svg" alt="prev" />
              <img src="/static/media/next-arrow-blue.f8cef0ba8265dcb8db9f3a350c8f5a52.svg" alt="next" />
            </div>
          </div>
          <div className="img"><img src="/static/media/about-us-values.b16b11ec121ee62d1f21.webp" alt="our values" /></div>
        </div>
      </section>
      <section className="our-mission">
        <h2 className="title">Our Mission</h2>
        <p className="sub-title">Our mission has always been to empower our customers to take control of their finances and build a better financial future. We believe that everyone deserves access to high-quality banking services, regardless of their financial situation. We're committed to making banking simple, accessible, and affordable for everyone, and we're dedicated to helping our customers achieve their financial goals.</p>
      </section>
      <section className="our-team">
        <h2 className="title">Our Team</h2>
        <div className="info-img">
          <div className="info">
            <p>Our team of banking experts is here to help you every step of the way. From our knowledgeable customer service representatives to our experienced loan officers and investment advisors, we have the expertise you need to make informed financial decisions and achieve your goals.</p>
            <p> We're proud of our team's expertise and commitment to customer service. We recruit only the best and brightest professionals in the banking industry, and we invest heavily in their training and development. Our team members are passionate about helping our customers achieve their financial goals, and they're always ready to go above and beyond to provide the best possible banking experience.</p>
          </div>
          <div className="img"><img src="/static/media/about-us-team.11e4765f88f6a265d48e.webp" alt="our team" /></div>
        </div>
      </section>
      <section className="our-goals">
        <h2 className="title">Our Goals</h2>
        <p className="sub-title">Our goal is to provide our customers with the best possible banking experience. We achieve this by focusing on the following goals:</p>
        <div className="cards">
          <div className="card">
            <h3>Integrity</h3>
            <p>We uphold the highest standards of integrity, transparency, and ethical behavior.</p>
          </div>
        </div>
      </section>
      <footer className="footer">
        <div className="grid">
          <div className="item logo-info">
            <div className="logo"></div>
          </div>
          <div className="item socials">
            <h3>Follow us</h3>
            <ul>
              <li><a href="#"><i className="fa fa-facebook"></i></a></li>
              <li><a href="#"><i className="fa fa-twitter"></i></a></li>
              <li><a href="#"><i className="fa fa-linkedin"></i></a></li>
            </ul>
          </div>
        </div>
        <div className="copyright">
          <p>Copyright 2022 Safenet Banking. Licensed by the Central Bank of United States.</p>
        </div>
      </footer>
    </main>
  );
}
